import { forwardRef } from "react";
import { ElementView } from "./ElementView";
import { assetUrl } from "@/lib/api";

export const SideBackground = ({ side }) =>
  side?.bgImage ? (
    <img src={assetUrl(side.bgImage)} alt="" crossOrigin="anonymous" draggable={false}
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
  ) : null;

const E = 0.05;
const canBleed = (el) => !el.rotation && !el.strokeWidth &&
  (el.type === "image" || (el.type === "rect" && el.fill && el.fill !== "transparent"));

// Elements touching a trim edge are stretched into the bleed area so colour runs edge-to-edge.
function bleedBox(el, tpl, b) {
  if (!b || !canBleed(el)) return { x: el.x + b, y: el.y + b, w: el.w, h: el.h };
  const x1 = el.x <= E ? -b : el.x, y1 = el.y <= E ? -b : el.y;
  const x2 = el.x + el.w >= tpl.width - E ? tpl.width + b : el.x + el.w;
  const y2 = el.y + el.h >= tpl.height - E ? tpl.height + b : el.y + el.h;
  return { x: x1 + b, y: y1 + b, w: x2 - x1, h: y2 - y1 };
}

export const CardSide = forwardRef(function CardSide(
  { tpl, side = "front", data, scale, editing = false, rounded = false, className = "", testId, bleed = 0 }, ref
) {
  const s = tpl[side] || { elements: [] };
  const b = bleed || 0;
  return (
    <div
      ref={ref}
      data-testid={testId}
      className={className}
      style={{
        position: "relative", overflow: "hidden", width: (tpl.width + 2 * b) * scale, height: (tpl.height + 2 * b) * scale,
        background: s.background || "#FFFFFF", borderRadius: rounded ? 3.18 * scale : 0, flexShrink: 0,
      }}
    >
      <SideBackground side={s} />
      {s.elements.filter((e) => !e.hidden).map((el) => {
        const bx = bleedBox(el, tpl, b);
        return (
          <div key={el.id} style={{
            position: "absolute", left: bx.x * scale, top: bx.y * scale, width: bx.w * scale, height: bx.h * scale,
            transform: `rotate(${el.rotation || 0}deg)`, opacity: el.opacity ?? 1,
          }}>
            <ElementView el={el} scale={scale} data={data} editing={editing} />
          </div>
        );
      })}
    </div>
  );
});
